import { NavLink, Link } from "react-router-dom";
import { useState } from "react";
import { logo } from "../assets/home";
import { useSiteContent } from "../context/SiteContentContext";
import Container from "./Container";

const isExternalLink = (path) => /^(https?:|mailto:|tel:)/i.test(path);

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const { navigation } = useSiteContent();
  const links = navigation.links ?? [];

  const renderLink = (link, mobile = false) => {
    const base = mobile
      ? "block border-b border-[#e7e3db] px-1 py-3 text-[15px] font-semibold last:border-0"
      : "nav-link whitespace-nowrap py-5 text-[13px] font-semibold lg:text-sm";

    if (isExternalLink(link.path)) {
      return <a key={link.path} href={link.path} className={base}>{link.label}</a>;
    }

    return (
      <NavLink
        key={link.path}
        to={link.path}
        onClick={() => setIsOpen(false)}
        className={({ isActive }) => `${base} ${isActive ? "is-active" : ""}`}
      >
        {link.label}
      </NavLink>
    );
  };

  return (
    <header className="sticky top-0 z-40 border-b border-[#e7e3db] bg-[rgba(250,249,246,0.96)] backdrop-blur-md">
      <Container>
        <div className="flex min-h-[74px] items-center justify-between gap-5">
          <Link to="/" className="flex shrink-0 items-center gap-3" aria-label="الصفحة الرئيسية">
            <img className="h-11 w-auto" src={logo} alt={navigation.logoAlt} />
            <span className="hidden border-r border-[#d9d3c8] pr-3 text-right lg:block">
              <strong className="block text-[15px] text-[#252923]">كنيسة مار الياس</strong>
              <small className="block text-[11px] text-[#77766f]">الرعية الملكية الكاثوليكية - فسوطة</small>
            </span>
          </Link>

          <nav className="hidden items-center gap-5 2xl:flex" aria-label="القائمة الرئيسية">
            {links.map((link) => renderLink(link))}
          </nav>

          <button
            onClick={() => setIsOpen(!isOpen)}
            type="button"
            className="grid h-10 w-10 place-items-center border border-[#d7d2c8] bg-white text-[#252923] 2xl:hidden"
            aria-controls="mobile-menu"
            aria-expanded={isOpen}
            aria-label={isOpen ? "إغلاق القائمة" : "فتح القائمة"}
          >
            <span className="text-xl leading-none" aria-hidden="true">{isOpen ? "×" : "☰"}</span>
          </button>
        </div>

        {isOpen && (
          <nav id="mobile-menu" className="grid border-t border-[#e7e3db] pb-4 sm:grid-cols-2 2xl:hidden" aria-label="القائمة الرئيسية للهاتف">
            {links.map((link) => renderLink(link, true))}
          </nav>
        )}
      </Container>
    </header>
  );
}

export default Navbar;
